import { gql } from '@apollo/client';

export const UPDATE_VIEW_SETTINGS = gql`
mutation UpdateViewSetting($type: String!, $meta: String!){
    upsertSetting(type: $type, meta: $meta){
        type
        meta
    }
}`;
